import { render, staticRenderFns } from "./UpdateCover.vue?vue&type=template&id=5e83b4f0"
import script from "./UpdateCover.vue?vue&type=script&lang=js"
export * from "./UpdateCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports